import { render, staticRenderFns } from "./TeamDashboard.vue?vue&type=template&id=a58a94d6&scoped=true&"
import script from "./TeamDashboard.vue?vue&type=script&lang=js&"
export * from "./TeamDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58a94d6",
  null
  
)

export default component.exports